import React from 'react';
import { Button } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

type BootstrapButtonProps = React.ComponentProps<typeof Button>;
interface AppButtonProps extends Omit<BootstrapButtonProps, 'children'> {
  label?: React.ReactNode;
  'data-testid'?: string;
}

export const AppButton = observer(function AppButton({
  label = 'Close',
  variant = 'primary',
  onClick,
  className,
  children,
  ...rest
}: AppButtonProps) {
  return (
    <Button variant={variant} onClick={onClick} className={className} {...rest}>
      {children ?? label}
    </Button>
  );
});
